module.exports = __webpack_public_path__ + "static/team-party-2-649cdb49acef39c3fc2df878184516ff.jpg";